export class AppUtils {

    //브라우저체크
    public static isBrowserCheck(): string {
        const agt = navigator.userAgent.toLowerCase();
        let browserNm = '';
        if (agt.indexOf('chrome') !== -1) {
            browserNm = 'Chrome';
        }else if (agt.indexOf('opera') !== -1) {
            browserNm = 'Opera';
        }else if (agt.indexOf('firefox') !== -1) {
            browserNm = 'Firefox';
        }else if (agt.indexOf('safari') !== -1) {
            browserNm = 'Safari';
        }else if (agt.indexOf('netscape') !== -1) {
            browserNm = 'Netscape';
        }else if (agt.indexOf('mozilla/5.0') !== -1) {
            browserNm = 'Mozilla';
            if (agt.indexOf('trident/')) {
                browserNm = 'Internet Explorer 11';
            }
        }else if (agt.indexOf('msie') !== -1) {
            // Regex 보안 이슈로 주석 처리
            // let rv = -1;
            // if (navigator.appName === 'Microsoft Internet Explorer') {
            //     let ua = navigator.userAgent;
            //     let re = new RegExp('MSIE ([0-9]{1,}[\.0-9]{0,})');
            //     if (re.exec(ua) !== null) {
            //         rv = parseFloat(RegExp.$1);
            //     }
            // }
            // browserNm = 'Internet Explorer ' + rv;
            browserNm = 'Internet Explorer older version';
        } else {
            browserNm = 'Other';
        }
        return browserNm;
    }

    public static getUseTimezone() {
        const tz  = {
            tmznOfs: global['loginUser'].tmznAplyTypeCd === 'LOGIN_TIMEZONE' ? global['loginUser'].loginTmznOfs : global['loginUser'].prflTmznOfs,
            tmznCd: global['loginUser'].tmznAplyTypeCd === 'LOGIN_TIMEZONE' ? navigator.language.startsWith('ko') ? 'Asia/Seoul' : global['loginUser'].loginTmznCd : global['loginUser'].prflTmznCd
        };

        return tz;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/src/app.utils.ts